/** Marks a subtree that handles its own touch gestures, so pull-to-refresh ignores drags started inside it. */
export const DISABLE_PULL_TO_REFRESH_ATTRIBUTE = 'data-disable-pull-to-refresh';
